<template src="./institutionsPage.html"></template>

<script>
    import institutionsEndpoints from '../institutions.endpoints';
    import systemsEndpoints from '../../systems/systems.endpoints';
    import dataTableMixin from '../../../js/dataTableMixin.js';

    export default {
        name: 'institutions-page',
        mixins: [dataTableMixin],
        data() {
            return {
                dto: {
                    SearchText: '',
                    IncludeInactive: false,
                    PageNumber: 1,
                    PageRows: 100,
                    SortByColumn: 'Name',
                    SortDirection: 'asc',
                    IntermediaryID: null,
                    SystemID: null
                },
                dropdownFields: {
                    text: 'Text',
                    value: 'Value'
                },
				institutionsTableItems: {},
                institutionsTableSortBy: {
                    columns: [
                        {field: 'Name', direction: 'Ascending'},
                    ]
                },
            }
        },
        computed: {
            permissions() {
                return this.$store.state.PermissionsModule.institutionPermissions;
            },
            institutionsTableColumns() {
                let columns = [
                    {
                        type: 'iconTemplate',
                        iconName: 'edit',
                        width: '35px',
                        allowSorting: false
                    },
                    {
                        key: 'Name',
                        label: 'Name',
                        width: '250px',
                        clipMode: 'EllipsisWithTooltip',
                        allowSorting: true
                    },
                    {
                        key: 'DegreeType',
                        label: 'Degree Type',
                        width: '135px',
                        allowSorting: true
                    },
                    {
                        key: 'FundingType',
                        label: 'Funding',
                        width: '115px',
                        allowSorting: true
                    },
                    {
                        key: 'State',
                        label: 'State',
                        width: '130px',
                        allowSorting: true
                    },
                    {
                        key: 'SystemNames',
                        label: 'Systems',
                        clipMode: 'EllipsisWithTooltip',
                        allowSorting: true,
                        formatter: (column, data) => { 
                            return data.SystemNames.join(', ')
                        }
                    },
                    {
                        key: 'PrimaryIntermediaryName',
                        label: 'Primary Intermediary',
                        width: '175px',
                        clipMode: 'EllipsisWithTooltip',
                        allowSorting: true
                    },
                    {
                        key: 'AdditionalIntermediaryNames',
                        label: 'Addl Intermediaries',
                        clipMode: 'EllipsisWithTooltip',
                        allowSorting: true,
                        formatter: (column, data) => { 
                            return data.AdditionalIntermediaryNames.join(', ')
                        }
                    },
                    {
                        key: 'IsActive',
                        label: 'Status',
                        width: '100px',
                        allowSorting: false,
                        formatter: (column, data) => {
                            return data.IsActive === true ? 'Active' : 'Inactive';
                        }
                    },
                ];

                if (!this.permissions.CanUpdate) {
                    columns.shift()
                }

                return columns;
            }
        },
        methods: {
            updateIntermediaryDropdown() {
                this.$store.commit('setSystemOptions', []);
                this.$store.dispatch('getSystemOptions', this.dto.IntermediaryID)
                    .then(() => {
                        this.getAll();
                    });              
            },
            updateSystemDropdown(args) {
                if (args.isInteracted) {
                    this.getAll();
                }
            },
            getAll() {
				institutionsEndpoints.getAll(this.dto)
					.then((response) => {
                        this.institutionsTableItems = {
                            result: response.Rows,
                            count: response.NumberOfRecords,
                        }
					});
			},
            create() {
                if (this.permissions.CanCreate) {
                    let modalData = {
                        callback: this.getAll,
                    }
    
                    DMUtils.openApplicationModal('institutionsPreliminaryModal', modalData);
                }
            },
            update() {
                if (this.permissions.CanUpdate) {
                    let modalData = {
                        mode: 'edit',
                        dto: {},
                        callback: this.getAll,
                    };
    
                    institutionsEndpoints.getByID(this.selectedRow.rowData.InstitutionID)
                        .then((response) => {
                            modalData.dto = response;
                            DMUtils.openApplicationModal('institutionsEditModal', modalData);
                        });
                }
            },
        },
        created() {
			this.getAll();

            return this.$store.dispatch('getIntermediaryOptions')
                .then(() => {
                    return this.$store.dispatch('getSystemOptions', this.dto.IntermediaryID)
                })
                .then(() => {
                    return this.$store.dispatch('getStateOptions')
                })
                .then(() => {
                    return this.$store.dispatch('getDegreeTypes')
                })
                .then(() => {
                    return this.$store.dispatch('getFundingTypes')
                });
        },
    }
</script>
